export default "__VITE_ASSET__D7dau6c5__"